/**********************************************************************************************
MainContent.tsx - Wrapper of the eco efficiency calculator application
***********************************************************************************************/
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loader from "../common/Loader/Loader";
import KclGlovesHome from "../dashboard/KclGlovesHome";
import { kclRootState } from "../../store/gloveSelectorStore";
import {getAnalyticstLaunchScriptEnv } from "../../assets/js/utils.js"
//lazy import for remote js
const HeaderFooter = React.lazy(() => import("WacReusableComponentGroup/HeaderFooter"));
const MainContent = () => {
  const language = useSelector((state: kclRootState) => state?.glovesSelector?.language || "en");
  const [masterPageURL, setMasterpageURL] = useState<string>("");
  const [isMasterPageLoading, setIsMasterPageLoading] = useState<boolean>(true);
  useEffect(() => {
    let newpMasterpageUrl = "";
    if (language) {
      setIsMasterPageLoading(true);
      switch (language) {
        case "en":
          if (process.env.REACT_APP_HEADERFOOTER_EN_JSON_URL) {
            newpMasterpageUrl = process.env.REACT_APP_HEADERFOOTER_EN_JSON_URL || "";
          }
          break;
        case "de":
          if (process.env.REACT_APP_HEADERFOOTER_DE_JSON_URL) {
            newpMasterpageUrl = process.env.REACT_APP_HEADERFOOTER_DE_JSON_URL || "";
          }
          break;
        default:
          newpMasterpageUrl = "";
          break;
      }
      setMasterpageURL(newpMasterpageUrl);
      setTimeout(() => {
        setIsMasterPageLoading(false);
      }, 2000);
      { masterPageURL; }
    }
  }, [language]);
      if (!document.getElementById("pageLoadEvent")) {
        const scriptFile = document.createElement("script");
        scriptFile.id = "pageLoadEvent";
        scriptFile.src = "/js/pageloadevent.js";
        document.body.appendChild(scriptFile);
      }
    
  return (
    <div className="mainContent" role="main" id="myAeroFooterDvNew">
      {masterPageURL &&
        <React.Suspense fallback={<Loader />} > <HeaderFooter onError={() => null} jsonUrl={masterPageURL}>
          {isMasterPageLoading ? <Loader /> : <div className="kcl-container" id="gloves-wrapper"><KclGlovesHome /></div>}
        </HeaderFooter></React.Suspense>
      }
    </div >
  );
};
export default MainContent;
